import {IconName} from "../../utils";
import IconDocuments from "./IconDocuments";
import IconDocumentsCheck from "./IconDocumentsCheck";
import IconCheck from "./IconCheck";
import IconDelivery from "./IconDelivery";
import IconReturned from "./IconReturned";
import IconCanceled from "./IconCanceled";
import IconConfirm from "./IconConfirm";
import IconDelivering from "./IconDelivering";
import IconShoppingCart from "./IconShoppingCart";
import IconShieldCheck from "./IconShieldCheck";
import IconGift from "./IconGift";
import IconBell from "./IconBell";
import IconNextPage from "./IconNextPage";
import IconPrevPage from "./IconPrevPage";
import IconDotsHoriZontal from "./IconDotsHoriZontal";
import IconWarming1 from "./IconWarming1";
import IconCheck2 from "./IconCheck2";
import IconTrash from "./IconTrash";
import IconX from "./IconX";
import IconMark1 from "./IconMark1";

const IconSvg = ({iconName, color, size}) => {
  switch (iconName) {
    case IconName.documents:
      return <IconDocuments color={color} size={size}/>;
    case IconName.documentCheck:
      return <IconDocumentsCheck color={color} size={size}/>;
    case IconName.check:
      return <IconCheck color={color} size={size}/>;
    case IconName.delivery:
      return <IconDelivery color={color} size={size}/>;
    case IconName.sellerOrder:
      return <IconDelivery color={color} size={size}/>;
    case IconName.returned:
      return <IconReturned color={color} size={size}/>;
    case IconName.canceled:
      return <IconCanceled color={color} size={size}/>;
    case IconName.confirm:
      return <IconConfirm color={color} size={size}/>;
    case IconName.delivering:
      return <IconDelivering color={color} size={size}/>;
    case IconName.shoppingCart:
      return <IconShoppingCart color={color} size={size}/>;
    case IconName.shieldCheck:
      return <IconShieldCheck color={color} size={size}/>;
    case IconName.gift:
      return <IconGift color={color} size={size}/>;
    case IconName.bell:
      return <IconBell color={color} size={size}/>;
    case IconName.nextPage:
      return <IconNextPage color={color} size={size}/>;
    case IconName.prevPage:
      return <IconPrevPage color={color} size={size}/>;
    case IconName.dotsHorizontal:
      return <IconDotsHoriZontal color={color} size={size}/>;
    case IconName.warming1:
      return <IconWarming1 color={color} size={size}/>;
    case IconName.check2:
      return <IconCheck2 color={color} size={size}/>;
    case IconName.trash:
      return <IconTrash color={color} size={size}/>;
    case IconName.X:
      return <IconX color={color} size={size}/>;
    case IconName.mark1:
      return <IconMark1 color={color} size={size}/>;
    default:
      return null;
  }
};
export default IconSvg;
